import * as request from 'services/request'
import { notification as notify } from 'utils'
import { browserHistory } from 'react-router'
import { startWidget, notifyError } from 'pages/widgets/util'
import { formToWidget } from 'pages/widgets/mapping'
import twitterValidationError from 'pages/widgets/validation'

export const createWidget = saveAndStart => (
  dispatch,
  getState
) => async formValues => {
  try {
    const { name, type, uniqueCodes, uniqueCodesFileName } = formValues
    const widget = formToWidget(formValues)
    const { users } = getState()
    const owner = users.find(user => user.id === widget.ownerId)

    if (!owner.hasTwitterTokens) {
      notify.error({
        title: `Failed to save experience "${name}"`,
        message: `The experience owner '@${owner.screenName}', needs to reauthenticate.`
      })
      return
    }

    if (
      twitterValidationError({
        ownerId: widget.ownerId,
        values: widget.widgetData
      })
    ) {
      return
    }

    try {
      const response = await request.authorized('/widgets', {
        method: 'POST',
        body: widget
      })

      const newWidget = await response.json()
      if (uniqueCodes && uniqueCodes.length > 0 && uniqueCodesFileName) {
        await request.authorized(`/unique-code-lists`, {
          method: 'POST',
          body: {
            uniqueCodes,
            name: uniqueCodesFileName,
            widgetId: newWidget.id
          }
        })
      }

      notify.success({
        message: `Experience '${name}' saved successfully!`
      })

      if (saveAndStart) {
        await startWidget(newWidget)
      }

      browserHistory.push(
        `/experiences/${type.toLowerCase()}/${newWidget.id}/edit`
      )
    } catch (e) {
      notifyError(e, name)
    }
  } catch (e) {
    console.error(e)
  }
}



// WEBPACK FOOTER //
// ./src/pages/widgets/form-actions/create/actions.js